module.exports = __webpack_public_path__ + "static/media/435_DiningRoomClose.64e9f84a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_DiningRoomClose.jpg
// module id = 559
// module chunks = 0